// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_logo_not_logged-module__logoNotLogged--28eev{display:flex;margin-right:145px;align-items:center;justify-content:flex-start}@media screen and (max-width: 79.9375em){.header_logo_not_logged-module__logoNotLogged--28eev{margin-right:36px}}@media screen and (max-width: 62.5625em){.header_logo_not_logged-module__logoNotLogged--28eev{margin-right:0px}}@media screen and (max-width: 48em){.header_logo_not_logged-module__logoNotLogged--28eev{width:auto}}\n", ""]);
// Exports
exports.locals = {
	"logoNotLogged": "header_logo_not_logged-module__logoNotLogged--28eev"
};
module.exports = exports;
